import { Pipe, PipeTransform } from '@angular/core';
import { isEmptyOrNotSet } from '@hints/utils/data';
import { round } from '@hints/utils/math';

@Pipe({
  name: 'measure',
  standalone: true,
})
export class MeasurePipe implements PipeTransform {

  transform(value: number, suffix: string = ''): string {
    if(isEmptyOrNotSet(value)) return 'N/A';
    return `${round(value)} ${suffix}`;
  }

}
